import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { ContributorConnection } from "../../types/contributor";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
  formatEvidenceName,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";

const columnHelper = createMRTColumnHelper<ContributorConnection>();

export const contributorColumns: MRT_ColumnDef<ContributorConnection, any>[] = [
  columnHelper.accessor("fromDoc", {
    header: "From",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "To Person",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("system_contribution_type", {
    header: "Contribution Type",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("status", {
    header: "Status",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("role", {
    header: "Role",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("place_identification_status", {
    header: "Place Identification Status",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("place", {
    id: "place",
    header: "Place",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("name_internal_evidence", {
    header: "Name Internal Evidence",
    Cell: ({ cell }) => {
      const val = cell.getValue();
      return val ? formatEvidenceName(val) : "-";
    },
  }),
  columnHelper.accessor("name_external_evidence", {
    header: "Name External Evidence",
    Cell: ({ cell }) => {
      const val = cell.getValue();
      return val ? formatEvidenceName(val) : "-";
    },
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

// fromDoc/toDoc/place are excluded: they display enriched refs
// (or edge data), but the backend filters run before enrichment and only
// accepts the underlying `_id` fields, not the resolved objects.
export const contributorFilterSpec: FilterSpec = createConnectionFilterSpec({
  system_contribution_type: { kind: "string" },
  status: { kind: "string" },
  role: { kind: "string" },
  place_identification_status: { kind: "string" },
  name_internal_evidence: { kind: "string" },
  name_external_evidence: { kind: "string" },
});

export default contributorColumns;
